import WeekDaysForm from 'containers/Layout/forms/WeekDays';

const WeekDaysView = () => <WeekDaysForm />;

export default WeekDaysView;
